import lazyframe from 'lazyframe';

document.addEventListener('turbolinks:load', function (event) {
    lazyframe('.lazyframe');
});